/**
 * reCAPTCHA Enterprise Form Handler
 * Oasis Media Center Frontend
 *
 * Handles reCAPTCHA Enterprise callback and form submission
 * for register and recovery pages.
 *
 * Usage: Add data-recaptcha-form="formId" to the .g-recaptcha button.
 * The global onSubmit() is called by reCAPTCHA Enterprise after verification.
 */

/**
 * Global reCAPTCHA callback — called by Google reCAPTCHA Enterprise
 * after successful verification. Submits the associated form.
 */
window.onSubmit = function(token) {
    // Find the recaptcha button that triggered this
    const button = document.querySelector('.g-recaptcha');
    if (!button) return;

    const formId = button.dataset.recaptchaForm || button.closest('form')?.id;
    const form = formId ? document.getElementById(formId) : button.closest('form');

    if (!form) {
        console.error('reCAPTCHA: No form found for submission');
        return;
    }

    // Visual feedback — show verified state
    const originalHTML = button.innerHTML;
    button.innerHTML = '<i class="fas fa-shield-alt"></i> Verificado';
    button.style.background = '#4CAF50';

    setTimeout(() => {
        form.submit();
    }, 800);
};

/**
 * Initialize reCAPTCHA button behavior on DOMContentLoaded
 */
document.addEventListener('DOMContentLoaded', function() {
    const button = document.querySelector('.g-recaptcha');
    if (!button) return;

    // Add loading spinner on click while reCAPTCHA verifies
    button.addEventListener('click', function() {
        if (this.disabled) return;

        const originalHTML = this.innerHTML;
        this.innerHTML = '<i class="fas fa-spinner fa-spin"></i> Verificando...';
        this.disabled = true;

        // Timeout safety — re-enable if reCAPTCHA takes too long
        setTimeout(() => {
            if (this.disabled) {
                this.innerHTML = originalHTML;
                this.disabled = false;
            }
        }, 5000);
    });
});
